import { sendRequest } from "@infrastructure/api/api";
import type ApiResponse from "@core/types/apiResponse";
import type { ApiMessageResponse } from "@core/types/apiMessageResponse";
import type { ReportProcessResult } from "./types";
import type { DepartmentReportScope, RequestDepartmentReportSavePayload } from "./requestDepartmentReportSave";
import { appendDepartmentReportMediaFormData } from "./requestDepartmentReportSave";

export interface RequestDepartmentReportSubmitPayload
  extends Omit<RequestDepartmentReportSavePayload, "scope"> {
  scope: DepartmentReportScope;
}

export type RequestDepartmentReportSubmitResponse = ApiMessageResponse & {
  process_report?: ReportProcessResult;
  [k: string]: unknown;
};

function buildBasePath(scope: DepartmentReportScope, ids: RequestDepartmentReportSubmitPayload): string {
  if (scope === "church") {
    if (!ids.churchId) throw new Error("churchId is required for scope=church");
    return `/church/${ids.churchId}`;
  }

  if (scope === "district") {
    if (!ids.districtId) throw new Error("districtId is required for scope=district");
    return `/district/${ids.districtId}`;
  }

  const nationId = ids.nationId;
  if (!nationId) throw new Error("nationId is required for scope=nation");
  return `/nation/${nationId}`;
}

/**
 * Submit department report (sets status to SUBMITTED).
 * Expected endpoint: /{scopeBase}/department/{departmentId}/report/submit
 */
export async function requestDepartmentReportSubmitAsync(
  payload: RequestDepartmentReportSubmitPayload
): Promise<ApiResponse<RequestDepartmentReportSubmitResponse>> {
  const base = buildBasePath(payload.scope, payload);

  const url = `${base}/department/${payload.departmentId}/report/submit`;

  const body = new FormData();
  body.append("report_tag_id", String(payload.reportTagId));
  if (payload.notes != null) body.append("notes", payload.notes);
  appendDepartmentReportMediaFormData(body, payload.attachments, payload.existingMedia);

  return sendRequest<FormData, RequestDepartmentReportSubmitResponse>("POST", url, body);
}